<template>
  <ul class="linear-info">
    <li>
      Mi nombre es <span>{{ $store.getters.getInitForm.name }}</span>
    </li>
    <li>
      Tengo <span>{{ $store.getters.getInitForm.age }}</span> años
    </li>
    <li>
      Vivo en
      <span
        >{{ $store.getters.getInitForm.city }},
        {{ $store.getters.getInitForm.province }}</span
      >
    </li>
  </ul>
</template>

<script>
export default { name: "DataInit" };
</script>

<style scoped>
.linear-info {
  margin: 0;
  padding: 0;
  display: grid;
  grid-gap: 5px;
  grid-template-columns: auto auto auto;
  justify-content: space-between;
  width: 100%;
}
.linear-info li {
  text-align: center;
  /* display: grid; */
  font-size: 25px;
  color: #00758f;
}
span {
  text-transform: uppercase;
}
@media screen and (max-width: 480px) {
  .linear-info {
    display: block;
  }
  .linear-info li {
    margin-bottom: 10px;
    font-size: 24px;
  }
  hr {
    margin: 2.5rem 0;
  }
}
</style>
